import api from './api';

export const authService = {
  // Login korisnika
  login: async (email, password, subdomain) => {
    const payload = { email, password };
    if (subdomain) {
      payload.subdomain = subdomain;
    }
    const response = await api.post('/auth/login', payload);
    if (response.token) {
      // Kombinuj user objekat sa tenantConnections iz top-level response-a
      // Ako tenantConnections nije definisan, koristi prazan array
      const tenantConnections = Array.isArray(response.tenantConnections) 
        ? response.tenantConnections 
        : [];
      
      const userWithConnections = {
        ...response.user,
        tenantConnections: tenantConnections
      };
      
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(userWithConnections));
    }
    return response;
  },

  // Registracija korisnika
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    if (response.token) {
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
    }
    return response;
  },

  // Dohvati trenutnog korisnika
  getCurrentUser: async () => {
    return await api.get('/auth/me');
  },

  // Ažuriraj profil
  updateProfile: async (profileData) => {
    return await api.put('/auth/profile', profileData);
  },

  // Promeni password
  changePassword: async (currentPassword, newPassword) => {
    return await api.put('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Ukloni demo mode flag-ove ako postoje
    localStorage.removeItem('demoMode');
    localStorage.removeItem('demoRole');
  },

  // Proveri da li je korisnik ulogovan
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Dohvati token
  getToken: () => {
    return localStorage.getItem('token');
  },

  // Dohvati korisnika iz localStorage
  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  sendForgotPassword: async (email) => {
    const response = await api.post(`/auth/forgot-password`, {email: email});
    return response;
  },

  confirmCode: async (data) => {
    const response = await api.post(`/auth/confirmCode`, data);
    return response.data;
  },

  resetPassword: async (data) =>{
    const response = await api.post(`/auth/reset-password`, data);
    return response;
  }
};

export default authService;




